import { render, staticRenderFns } from "./usergrowth.vue?vue&type=template&id=d54bfdc4&scoped=true&"
import script from "./usergrowth.vue?vue&type=script&lang=js&"
export * from "./usergrowth.vue?vue&type=script&lang=js&"
import style0 from "./usergrowth.vue?vue&type=style&index=0&id=d54bfdc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54bfdc4",
  null
  
)

export default component.exports